import { c as _c } from "react/compiler-runtime";
import type { TagGeneralSkillLevel } from '@algoacademy/backend/modules/tag/enums';
import { Button } from '@algoacademy/design-system/web/actions/Button';
import { H2 } from '@algoacademy/design-system/web/typography/Heading';
import { ArrowRightIcon } from '@heroicons/react/24/solid';
import { CourseCard } from './CourseCard';
type Course = {
  name: string;
  description: string;
  skills: {
    name: string;
    level: TagGeneralSkillLevel;
  }[];
};
type CoursesProps = {
  courses: Course[];
};
export function Courses(t0) {
  const $ = _c(8);
  const {
    courses
  } = t0;
  if (!courses || courses.length === 0) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <H2>Kursy, które prowadzę</H2>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== courses) {
    t2 = courses.map(_temp);
    $[1] = courses;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">{t2}</div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Button marketing={true} marketingVariant="outline" href="/kursy" className="w-fit">Pokaż wszystkie kursy <ArrowRightIcon className="h-4 w-4" /></Button>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <div className="flex flex-col items-center space-y-6 self-stretch">{t1}{t3}{t4}</div>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}
function _temp(course) {
  return <CourseCard key={course.name} course={course} />;
}